import Default from './Default';
import Outlined from './Outlined';

const Logo = (props) => {
  const { outline, light, height } = props;
  return outline ? <Outlined {...props} /> : <Default height={height} light={light} />;
};

export default Logo;